import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-75b2cff2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "signature-pad-container" };
const _hoisted_2 = { class: "signature-container" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "text-support-line" }, null, -1));
const _hoisted_4 = {
    key: 0,
    class: "signature-info-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_VueSignaturePad = _resolveComponent("VueSignaturePad");
    const _component_FriedIcon = _resolveComponent("FriedIcon");
    const _component_FriedRoundedButton = _resolveComponent("FriedRoundedButton");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_VueSignaturePad, {
                id: "signature-box",
                ref: "signaturePad",
                "data-external": "signature-container-signature-box",
                width: _ctx.width,
                height: _ctx.height,
                options: _ctx.options,
                "save-type": _ctx.saveType,
                onMouseover: _ctx.hideText
            }, null, 8, ["width", "height", "options", "save-type", "onMouseover"]),
            _hoisted_3,
            (_ctx.showInfoTextSection)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.t('draw-your-signature-here')), 1))
                : _createCommentVNode("", true)
        ]),
        _createVNode(_component_FriedRoundedButton, {
            "data-external": "draw-signature-clear",
            class: "clear-signature-button",
            "hide-text-mobile": "",
            "icon-align-right": "",
            onClick: _ctx.undo
        }, {
            icon: _withCtx(() => [
                _createVNode(_component_FriedIcon, { icon: "arrow-undo" })
            ]),
            default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(_ctx.t('undo')), 1)
            ]),
            _: 1
        }, 8, ["onClick"])
    ]));
}
